import { render, staticRenderFns } from "./AdditionalPax.vue?vue&type=template&id=43fe5cc0&scoped=true&"
import script from "./AdditionalPax.vue?vue&type=script&lang=js&"
export * from "./AdditionalPax.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalPax.vue?vue&type=style&index=0&id=43fe5cc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fe5cc0",
  null
  
)

export default component.exports